export function getCookie(cname: string) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export function updateCookie(cname: string, cval: string, expSec?: number) {
  var expires = "";
  if (expSec) {
    var date = new Date();
    date.setTime(date.getTime() + expSec);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = cname + "=" + (cval || "") + expires + "; path=/";
}

export function removeCookie(cname: string) {
  document.cookie = cname + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}